@let model = tiers();
<p-dialog
  styleClass="tf-billing-pricing-tiers-dialog"
  [modal]="true"
  [visible]="model !== null"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [header]="
    model
      ? ('SETTINGS_BILLING.PLAN.METERS.PRICING_DIALOG.TITLE'
          | translate: { meter: model.title })
      : ''
  "
  (visibleChange)="onVisibleChange($event)">
  @if (model) {
    <p-table [value]="model.rows" styleClass="tf-billing-pricing-tiers-dialog__table">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'SETTINGS_BILLING.PLAN.METERS.PRICING_DIALOG.RANGE' | translate }}</th>
          <th>{{ 'SETTINGS_BILLING.PLAN.METERS.PRICING_DIALOG.PRICE' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.rangeLabel }}</td>
          <td>{{ row.priceLabel }}</td>
        </tr>
      </ng-template>
    </p-table>
  }
</p-dialog>
